export default {
  es: {
    app: {
      title: 'Kontigo Express',
      brand: 'Kontigo',
      product: 'Express',
    },
    messages: {
      processing: 'Procesando',
      uploading: 'Procesando archivo',
      unauthorized: 'Acceso denegado',
      verified: 'Verificado',
      valid: 'V\u00E1lido',
      invalid: 'No v\u00E1lido',
      info: 'Informaci\u00F3n',
    },
    languages: {
      es: 'Espa\u00F1ol',
      en: 'Ingl\u00E9s',
    },
    views: {
      app: {
        actions: {
          login: {
            label: 'Ingresar',
          },
        },
      },
      welcome: {
        form0: {
          title: {
            title: 'Préstamos en línea por',
            subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod',
          },
        },
      },
      login: {
        formLogin: {
          title: {
            title: '\u00A1Bienvenido!',
          },
          username: {
            label: 'Usuario',
            placeholder: 'Usuario',
          },
          codigo: {
            label: 'Código',
            placeholder: 'Código',
          },
          password: {
            label: 'Contrase\u00F1a',
            placeholder: 'Contrase\u00F1a',
          },
          rememberme: {
            label: 'Recordarme',
          },
          actions: {
            login: {
              label: 'Ingresar',
            },
            forgotPassword: {
              label: '\u00BFOlvidaste tu contrase\u00F1a?',
            },
          },
        },
        formRequestResetPassword: {
          title: {
            title: 'Solicitar el restablecimiento de la contrase\u00F1a',
          },
          email: {
            label: 'Correo electr\u00F3nico',
            placeholder: 'Correo electr\u00F3nico',
          },
          actions: {
            resetPassword: {
              label: 'Restablecer contrase\u00F1a',
            },
            login: {
              label: 'Iniciar sesi\u00F3n',
            },
          },
        },
      },
      resetPassword: {
        formResetPassword: {
          title: {
            title: 'Restablecer contrase\u00F1a',
          },
          password: {
            label: 'Contrase\u00F1a',
            placeholder: 'Contrase\u00F1a',
          },
          confirmPassword: {
            label: 'Confirmar contrase\u00F1a',
            placeholder: 'Confirmar contrase\u00F1a',
          },
          actions: {
            resetPassword: {
              label: 'Restablecer contrase\u00F1a',
            },
            login: {
              label: 'Iniciar sesi\u00F3n',
            },
          },
        },
      },
      registroSolicitud: {
        datosPersonales: {
          title: {
            title: 'Registro de solicitud',
            steps: '1 de 4',
            subtitle: 'Ingresa los datos personales',
          },
          formDatosPersonales: {
            today: {
              label: 'la Fecha actual',
            },
            tipoDocumentoId: {
              label: 'Tipo de documento',
              placeholder: 'Tipo de documento',
            },
            numDocumento: {
              label: 'N\u00FAmero de documento',
              placeholder: 'N\u00FAmero de documento',
            },
            fechaVencimientoDoi: {
              label: 'Fecha de vencimiento DOI',
              placeholder: 'Fecha de vencimiento DOI',
            },
            nombres: {
              label: 'Nombres completos',
              placeholder: 'Nombres completos',
            },
            apellidoPaterno: {
              label: 'Primer apellido',
              placeholder: 'Primer apellido',
            },
            apellidoMaterno: {
              label: 'Segundo apellido',
              placeholder: 'Segundo apellido',
            },
            fechaNacimiento: {
              label: 'Fecha de nacimiento',
              placeholder: 'Fecha de nacimiento',
            },
            correo: {
              label: 'Correo electr\u00F3nico',
              placeholder: 'Correo electr\u00F3nico',
            },
            numCelular: {
              label: 'N\u00FAmero de celular',
              placeholder: 'N\u00FAmero de celular',
            },
            operadorId: {
              label: 'Operador',
              placeholder: 'Operador',
            },
            sexo: {
              label: 'Sexo',
              placeholder: 'Sexo',
            },
            estadoCivilId: {
              label: 'Estado civil',
              placeholder: 'Estado civil',
            },
            tipoDoiConyugue: {
              label: 'Tipo de DOI c\u00F3nyuge',
              placeholder: 'Tipo de DOI c\u00F3nyuge',
            },
            numDoiConyugue: {
              label: 'N\u00FAmero de DOI c\u00F3nyuge',
              placeholder: 'N\u00FAmero de DOI c\u00F3nyuge',
            },
            nombreConyugue: {
              label: 'Nombre del c\u00F3nyuge',
              placeholder: 'Nombre del c\u00F3nyuge',
            },
            actions: {
              submit: {
                label: 'Continuar',
              },
            },
          },
        },
        datosVivienda: {
          title: {
            title: 'Registro de solicitud',
            steps: '2 de 4',
            subtitle: 'Ingresa los datos de vivienda',
          },
          formDatosVivienda: {
            today: {
              label: 'la Fecha actual',
            },
            paisId: {
              label: 'Pais',
              placeholder: 'Pais',
            },
            departamentoId: {
              label: 'Departamento',
              placeholder: 'Departamento',
            },
            provinciaId: {
              label: 'Provincia',
              placeholder: 'Provincia',
            },
            distritoId: {
              label: 'Distrito',
              placeholder: 'Distrito',
            },
            tipoViaId: {
              label: 'Tipo de v\u00EDa',
              placeholder: 'Tipo de v\u00EDa',
            },
            nombreVia: {
              label: 'Nombre de v\u00EDa',
              placeholder: 'Nombre de v\u00EDa',
            },
            manzana: {
              label: 'Mz.',
              placeholder: 'Mz.',
            },
            lote: {
              label: 'Lote',
              placeholder: 'Lote',
            },
            numExterior: {
              label: 'Nro exterior',
              placeholder: 'Nro exterior',
            },
            numInterior: {
              label: 'Nro interior',
              placeholder: 'Nro interior',
            },
            nombreUbicacion: {
              label: 'Nombre ubicaci\u00F3n',
              placeholder: 'Nombre ubicaci\u00F3n',
            },
            tipoUbicacionId: {
              label: 'Tipo de ubicaci\u00F3n',
              placeholder: 'Tipo de ubicaci\u00F3n',
            },
            referencia: {
              label: 'Referencia',
              placeholder: 'Referencia',
            },
            resideDesde: {
              label: 'Reside desde',
              placeholder: 'Reside desde',
            },
            relacionViviendaId: {
              label: 'Tipo de vivienda',
              placeholder: 'Tipo de vivienda',
            },
            gastosAlquiler: {
              label: 'Gastos de alquiler (soles)',
              placeholder: 'Gastos de alquiler (soles)',
            },
            numUnidadFam: {
              label: 'N\u00FAmero de dependientes',
              placeholder: 'N\u00FAmero de dependientes',
              info: 'N\u00FAmero de personas que dependen de sus ingresos',
            },
            actions: {
              submit: {
                label: 'Continuar',
              },
            },
          },
        },
        datosContacto: {
          title: {
            subtitle: 'Datos de contacto',
          },
          formDatosContacto: {
            numCelular: {
              label: 'N\u00FAmero de celular',
              placeholder: 'N\u00FAmero de celular',
            },
            operadorId: {
              label: 'Operador',
              placeholder: 'Operador',
            },
            correoElectronico: {
              label: 'Correo electr\u00F3nico',
              placeholder: 'Correo electr\u00F3nico',
            },
          },
        },
        datosLaborales: {
          title: {
            title: 'Registro de solicitud',
            steps: '3 de 4',
            subtitle: 'Ingresa los datos laborales',
          },
          formDatosLaborales: {
            today: {
              label: 'la Fecha actual',
            },
            empresaConvenioId: {
              label: 'Empresa',
              placeholder: 'Empresa',
            },
            inicioLaboral: {
              label: 'Inicio Laboral',
              placeholder: 'Inicio Laboral',
            },
            frecuenciaPagoId: {
              label: 'Frecuencia de pago',
              placeholder: 'Frecuencia de pago',
            },
            condicionLaboralId: {
              label: 'Condici\u00F3n laboral',
              placeholder: 'Condici\u00F3n laboral',
            },
            actividadEconomicaId: {
              label: 'Actividad econ\u00F3mica',
              placeholder: 'Actividad econ\u00F3mica',
            },
            tipoIngreso: {
              label: 'Tipo de ingreso',
              placeholder: 'Tipo de ingreso',
              options: [{
                label: 'Fijo',
              }, {
                label: 'Variable',
              }],
            },
            ingreso1: {
              label: 'Ingreso 1 (soles)',
              placeholder: 'Ingreso 1 (soles)',
            },
            ingreso2: {
              label: 'Ingreso 2 (soles)',
              placeholder: 'Ingreso 2 (soles)',
            },
            ocupacionId: {
              label: 'Ocupaci\u00F3n / Cargo',
              placeholder: 'Ocupaci\u00F3n / Cargo',
            },
            registroEmpresa: {
              label: 'C\u00F3digo de empleado',
              placeholder: 'C\u00F3digo de empleado',
              info: 'Lorem ipsum',
            },
            actions: {
              submit: {
                label: 'Continuar',
              },
            },
          },
        },
        resumenRegistro: {
          title: {
            title: 'Registro de solicitud',
            steps: '4 de 4',
            subtitle: 'Revisa el resumen de registro',
          },
          formResumenRegistro: {
            confDatosCorrectos: {
              label: 'Confirmo que los datos que he ingresado son los proporcionados por el cliente.',
              placeholder: 'Confirmo que los datos que he ingresado son los proporcionados por el cliente.',
              alias: 'Confirmar',
              helper: 'La informaci\u00F3n brindada por EL CLIENTE tiene car\u00E1cter de Declaraci\u00F3n Jurada, seg\u00FAn lo establecido por el art\u00EDculo 179\u00B0 de la Ley N\u00B026702.',
            },
            actions: {
              submit: {
                label: 'Registrar',
              },
            },
          },
        },
        datosSolicitante: {
          title: {
            title: 'Solicitud y evaluaci\u00F3n de pr\u00E9stamo',
            steps: '1 de 4',
            subtitle: 'Analiza los datos del solicitante',
          },
          formDatosFinanciamiento: {
            codigoSolicitante: {
              label: 'C\u00F3digo de expediente',
              placeholder: 'C\u00F3digo de expediente',
            },
            productoId: {
              label: 'Producto',
              placeholder: 'Producto',
            },
            tipoProducto: {
              label: 'Tipo de producto',
              placeholder: 'Tipo de producto',
              options: [{
                label: 'Nuevo',
              }, {
                label: 'Subrogado',
              }],
            },
            subProductoId: {
              label: 'Subproducto',
              placeholder: 'Subproducto',
            },
            montoPrestamo: {
              label: 'Monto (soles)',
              placeholder: 'Monto (soles)',
            },
            campaniaConvenioId: {
              label: 'C\u00F3digo de campa\u00F1a',
              placeholder: 'C\u00F3digo de campa\u00F1a',
            },
            plazo: {
              label: 'Plazo (meses)',
              placeholder: 'Plazo (meses)',
            },
            diaPago: {
              label: 'Día de pago',
              placeholder: 'Día de pago',
            },
            tipoCuotaId: {
              label: 'Tipo de cuota',
              placeholder: 'Tipo de cuota',
            },
            tasa: {
              label: 'Tasa % (TEA)',
              placeholder: 'Tasa % (TEA)',
            },
            boletaPago: {
              label: 'Adjuntar boleta de pago',
              placeholder: 'M\u00E1ximo 5MB',
            },
            actions: {
              submit: {
                label: 'Siguiente',
              },
            },
          },
        },
        components: {
          confirm: {
            ok: {
              title: {
                title: '\u00BFDesea confirmar la operaci\u00F3n?',
              },
              actions: {
                reject: {
                  label: 'Rechazar',
                },
                confirm: {
                  label: 'Confirmar',
                },
              },
            },
            confirmReject: {
              title: {
                title: '\u00BFEst\u00E1s seguro de querer rechazar?',
                subtitle: 'Los datos que has completado hasta el momento no se guardar\u00E1n. As\u00ED que, cuando quieras retomar el proceso, deber\u00E1s llenarlo nuevamente.',
              },
              actions: {
                confirm: {
                  label: 'Confirmar',
                },
              },
            },
            reject: {
              title: {
                title: 'Motivo de rechazo',
              },
              actions: {
                confirm: {
                  label: 'Confirmar',
                },
              },
            },
          },
          dictamen: {
            cronograma: {
              title: {
                title: 'Cronograma de pagos',
              },
              actions: {
                show: {
                  label: 'Cronograma de pagos',
                },
                send: {
                  label: 'Enviar por correo el Cronograma',
                },
              },
            },
          },
        },
        evaluacion: {
          title: {
            title: 'Evaluaci\u00F3n exitosa',
            subtitle: 'Tu pr\u00E9stamo est\u00E1 aprobado',
          },
          actions: {
            newSimulation: {
              label: 'Nueva simulaci\u00F3n',
            },
            close: {
              label: 'Finalizar',
            },
          },
        },
        simulacion: {
          title: {
            title: 'Simulaci\u00F3n de solicitud',
            steps: '1 de 3',
            subtitle: 'Ingresa los datos del pr\u00E9stamo',
          },
          formCalculate: {
            montoPrestamoFinal: {
              label: 'S/',
              placeholder: 'S/',
            },
            plazo: {
              label: 'Plazo (meses)',
              placeholder: 'Plazo (meses)',
            },
            diaPago: {
              label: 'Día de pago',
              placeholder: 'Día de pago',
            },
            tipoCuotaId: {
              label: 'Tipo de cuota',
              placeholder: 'Tipo de cuota',
              info: 'Lorem ipsum',
            },
            tasa: {
              label: 'Tasa',
              placeholder: 'Tasa',
            },
            actions: {
              calcular: {
                label: 'Calcular',
              },
            },
          },
          view0: {
            information: {
              title: {
                title: 'IMPORTANTE',
              },
              details: [
                'Este documento es una simulación preliminar.',
                'No se incluyen los gastos pagados por el cliente.',
                'El monto de amortizaci\u00F3n con este valor se origina por la aplicaci\u00F3n del c\u00E1lculo para la obtenci\u00F3n de cuota constante. No afecta el costo afectivo anual del cr\u00E9dito.',
                'Las operaciones realizadas en la cuenta se encuentran afectas al pago del impuesto por transacciones financieras (IFT): 0.005%',
                'Usted tiene derecho a elegir su propio seguro en el momento de la contrataci\u00F3n.',
                'La tasa de inter\u00E9s es fija.',
              ],
            },
          },
          actions: {
            submit: {
              label: 'Confirmar',
            },
          },
        },
        cuentaAhorros: {
          title: {
            title: 'Solicitud y evaluaci\u00F3n de pr\u00E9stamo',
            steps: '2 de 3',
            subtitle: 'Para realizar el desembolso del pr\u00E9stamo es necesario que tengas una cuenta en el BBVA. Por ello te ofrecemos la cuenta fácil (soles) que no te cobrar\u00E1 mantenimiento',
            endtitle: 'El desembolso del pr\u00E9stamo y la entrega de la tarjeta de d\u00E9bito es personal. Recordar al cliente que debe acercarse a la oficina BBVA de su preferencia con su DNI f\u00EDsico para realizar el proceso de identificaci\u00F3n.',
          },
          formCuentaAhorros: {
            tipoCuentaId: {
              label: 'Selecciona la cuenta de ahorros por aperturar y abonar tu cr\u00E9dito',
              placeholder: 'Selecciona tu cuenta para abonar tu cr\u00E9dito',
              alias: 'Cuenta de ahorros',
            },
            tieneCuentaAhorros: {
              label: '¿Solicitante tiene cuenta de ahorros en BBVA?',
              options: [{
                label: 'Si',
              }, {
                label: 'No',
              }],
            },
            tienePagoHaberes: {
              label: '¿Tiene pago de haberes con BBVA?',
              options: [{
                label: 'Si',
              }, {
                label: 'No',
              }],
            },
            trasladaPagoHaberes: {
              label: '¿Desea trasladar su pago de haberes al BBVA?',
              options: [{
                label: 'Si',
              }, {
                label: 'No',
              }],
            },
            actions: {
              submit: {
                label: 'Continuar',
              },
            },
          },
        },
        documentos: {
          title: {
            title: 'Solicitud y evaluaci\u00F3n de pr\u00E9stamo',
            steps: '3 de 3',
            subtitle: 'Ingresa los documentos',
          },
          formDocumentos: {
            actions: {
              submit: {
                label: 'Registrar',
              },
            },
          },
        },
        aprobacionCredito: {
          title: {
            title: 'Confirmaci\u00F3n de solicitud de pr\u00E9stamo',
          },
          actions: {
            confirm: {
              label: 'Confirmar',
            },
          },
        },
      },
      historialCreditos: {
        title: {
          title: 'Historial de cr\u00E9ditos',
        },
        formHistorialCreditos: {
          numDocumento: {
            label: 'N\u00FAmero de documento',
            placeholder: 'N\u00FAmero de documento',
          },
          usuarioId: {
            label: 'Seleccione al usuario Analista',
            placeholder: 'Usuario Analista',
          },
          estadoId: {
            label: 'Estado de la solicitud',
            placeholder: 'Estado de la solicitud',
          },
          cliente: {
            label: 'Nombres',
            placeholder: 'Nombres',
          },
          codigoSolicitante: {
            label: 'C\u00F3digo de expediente',
            placeholder: 'C\u00F3digo de expediente',
          },
          empresaConvenioId: {
            label: 'Convenio',
            placeholder: 'Convenio',
          },
          fechaInicio: {
            label: 'Desde',
            placeholder: 'Desde',
          },
          fechaFin: {
            label: 'Hasta',
            placeholder: 'Hasta',
          },
          actions: {
            submit: {
              label: 'Buscar',
            },
            download: {
              label: 'Descargar',
            },
          },
        },
      },
      detalleSolicitud: {
        title: {
          title: 'Solicitud',
        },
        actions: {
          return: {
            label: 'Volver',
          },
          confirm: {
            label: 'Confirmar',
          },
        },
      },
    },
  },
};
